import React from 'react';
import { Modal, Frame } from '@kajabi/sage-react';

import ApplyButton from 'common/components/CopyMagic/components/ApplyButton';
import GenerateButton from 'common/components/CopyMagic/components/GenerateButton';
import { useResultContext, useUiResourceContext } from 'common/components/CopyMagic/contexts';
import FeedbackSentiment from 'common/components/CopyMagic/components/FeedbackSentiment';

const FooterActions = () => {
  const { loading } = useUiResourceContext();
  const { result } = useResultContext();

  if (loading || !result) {
    return (
      <Modal.Footer>
        <GenerateButton fullWidth />
      </Modal.Footer>
    );
  }

  return (
    <Modal.Footer>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_SPREAD}
        direction={Frame.DIRECTIONS.HORIZONTAL}
        width={Frame.WIDTHS.FILL}
      >
        <FeedbackSentiment />
        <Frame
          align={Frame.ALIGNMENTS.CENTER_RIGHT}
          direction={Frame.DIRECTIONS.HORIZONTAL}
          width={Frame.WIDTHS.FLEX}
        >
          <GenerateButton tryAgain />
          <ApplyButton />
        </Frame>
      </Frame>
    </Modal.Footer>
  );
};

export default FooterActions;
